{
  "additional_products": "Aanvullende producten",
  "bikes": "Fietsen",
  "booking_summary": "Boekingssamenvatting",
  "cabins": "Hutten",
  "date": "Datum",
  "departure": "Vertrek",
  "local_costs": "Kosten op locatie",
  "port_of_departure": "Vertrekhaven",
  "ship": "Schip",
  "tour": "Reis"
}
